export interface Creator {
  id: string;
  name: string;
  avatar: string;
  bio: string;
  followers: number;
  videoCount: number;
  totalLikes: number;
  verified: boolean;
}

export const topCreators: Creator[] = [
  {
    id: 'c001',
    name: '猫咪观察员',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20cat%20face%20profile%20picture%2C%20simple%20flat%20design%2C%20warm%20orange%20and%20cream%20colors%2C%20minimalist%20illustration%20style&width=200&height=200&seq=creator-avatar-001&orientation=squarish',
    bio: '专注记录猫咪日常，带你发现主子们的各种神奇操作！',
    followers: 2800000,
    videoCount: 356,
    totalLikes: 45000000,
    verified: true,
  },
  {
    id: 'c002',
    name: '厨房小当家',
    avatar: 'https://readdy.ai/api/search-image?query=Chef%20hat%20cartoon%20character%20profile%20picture%2C%20simple%20flat%20design%2C%20warm%20yellow%20and%20white%20colors%2C%20minimalist%20illustration%20style&width=200&height=200&seq=creator-avatar-002&orientation=squarish',
    bio: '用最简单的食材做出最惊艳的味道，跟我一起成为厨房王者！',
    followers: 1500000,
    videoCount: 289,
    totalLikes: 32000000,
    verified: true,
  },
  {
    id: 'c003',
    name: '游戏达人老A',
    avatar: 'https://readdy.ai/api/search-image?query=Game%20controller%20cartoon%20character%20profile%20picture%2C%20simple%20flat%20design%2C%20green%20and%20dark%20colors%2C%20minimalist%20illustration%20style&width=200&height=200&seq=creator-avatar-003&orientation=squarish',
    bio: '十年游戏老玩家，专注高难度攻略和速通挑战，带你领略游戏巅峰操作！',
    followers: 4200000,
    videoCount: 512,
    totalLikes: 89000000,
    verified: true,
  },
  {
    id: 'c004',
    name: '街头音乐人',
    avatar: 'https://readdy.ai/api/search-image?query=Music%20note%20cartoon%20character%20profile%20picture%2C%20simple%20flat%20design%2C%20warm%20pink%20and%20cream%20colors%2C%20minimalist%20illustration%20style&width=200&height=200&seq=creator-avatar-004&orientation=squarish',
    bio: '在世界各地的街头用音乐连接人心，每一段旋律都是一个故事。',
    followers: 3500000,
    videoCount: 198,
    totalLikes: 62000000,
    verified: true,
  },
  {
    id: 'c005',
    name: '旅行日记本',
    avatar: 'https://readdy.ai/api/search-image?query=Earth%20globe%20cartoon%20character%20profile%20picture%2C%20simple%20flat%20design%2C%20teal%20and%20white%20colors%2C%20minimalist%20illustration%20style&width=200&height=200&seq=creator-avatar-005&orientation=squarish',
    bio: '走遍50个国家的旅行博主，分享最实用的攻略和最震撼的风景。',
    followers: 1800000,
    videoCount: 245,
    totalLikes: 38000000,
    verified: true,
  },
  {
    id: 'c006',
    name: '数码测评室',
    avatar: 'https://readdy.ai/api/search-image?query=Circuit%20board%20cartoon%20character%20profile%20picture%2C%20simple%20flat%20design%2C%20gray%20and%20teal%20colors%2C%20minimalist%20illustration%20style&width=200&height=200&seq=creator-avatar-006&orientation=squarish',
    bio: '专业数码产品深度测评，帮你做出最聪明的购买决策。',
    followers: 2200000,
    videoCount: 178,
    totalLikes: 41000000,
    verified: true,
  },
];